// extracted by mini-css-extract-plugin
export default {"patientInfo":"patientInfo_nm9F2","content":"content_uM0rd","action":"action_C0Y9Q"};